import React from 'react';
import {Card} from '@mui/material';
import {TextField} from 'formik-mui';
import {Field, useFormikContext} from 'formik';
import FormikRemoteAutocompleteField from '../MasterData/components/FormikRemoteAutocompleteField';
import { mastersApi } from '../../../services/MasterDataServices';

export default function AcquisitionEntryOne({code}) {
  const {setFieldValue} = useFormikContext();

  const loadAcquisitionTypes = React.useCallback((params) => mastersApi('acquisitions', 'get', null, params), []);

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4}}>
        <FormikRemoteAutocompleteField
          name={'acquisition_type_id'}
          label={'Acquisition Type'}
          loadOptions={loadAcquisitionTypes}
          getOptionLabel={(o) => o?.name || o?.code || ''}
          onChange={(v) => setFieldValue('acquisition_type_id', v?.id ?? null)}
        />
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Owner'}
               name={`translations.${code}.owner`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Received From'}
               name={`translations.${code}.received_from`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Permanent Address'}
               name={`translations.${code}.permanent_address`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
      </Card>
    </div>
  );
}